<mdb-material-chips #chips [(ngModel)]="values" (labelsChange)="receiveValues($event)" class="d-block mt-3"></mdb-material-chips>
<button type="button" mdbBtn color="blue-grey" block="true" class="mt-2 z-depth-0" mdbWavesEffect (click)="onAdd()">{{ 'ADD' | translate }}</button>
